module.exports = __webpack_public_path__ + "img/icon-ean@3x.01f4acee.png";